var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OfficeBuildingOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 17.5V4.16667C15.8333 3.72464 15.6577 3.30072 15.3452 2.98816C15.0326 2.67559 14.6087 2.5 14.1667 2.5H5.83333C5.39131 2.5 4.96738 2.67559 4.65482 2.98816C4.34226 3.30072 4.16667 3.72464 4.16667 4.16667V17.5M15.8333 17.5H17.5M15.8333 17.5H11.6667M4.16667 17.5H2.5M4.16667 17.5H8.33333M11.6667 17.5V13.3333C11.6667 13.1123 11.5789 12.9004 11.4226 12.7441C11.2663 12.5878 11.0543 12.5 10.8333 12.5H9.16667C8.94565 12.5 8.73369 12.5878 8.57741 12.7441C8.42113 12.9004 8.33333 13.1123 8.33333 13.3333V17.5M11.6667 17.5H8.33333M7.5 5.83333H8.33333M7.5 9.16667H8.33333M11.6667 5.83333H12.5M11.6667 9.16667H12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildSb);
export default __webpack_public_path__ + "static/media/buildSB.f34974f16104ec9e9b24ccf73d7eb2ea.svg";
export { ForwardRef as ReactComponent };